/**
 * Formats a number with thousands separators for better readability
 * @param num - The number to format
 * @returns Formatted number string with spaces as thousand separators (Swedish format)
 */
export function formatNumber(num: number): string {
  // Use Swedish number formatting (space as thousand separator)
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
